<template>
  <layout>
    <!-- <div>
        <b-nav pills justified>
            <b-nav-item
                v-for="item in navigationsItems"
                :to="item.fouterTo"
                :key="item.id"
            >{{item.title}}</b-nav-item>
    </b-nav>-->
    <slot />
    <!-- </div> -->
  </layout>
</template>

<script>
export default {
  name: 'SmartOeeSettings',
  data() {
    return {
      navigationsItems: [
        {
          title: 'Profile',
          iconClass: 'mdi mdi-speedometer',
          fouterTo: '/settings/profile',
        },
        {
          title: 'Boxes',
          iconClass: 'mdi mdi-speedometer',
          fouterTo: '/settings/boxes',
        },
        {
          title: 'Billing',
          iconClass: 'mdi mdi-speedometer',
          fouterTo: '/settings/billing',
        },
      ],
    };
  },
};
</script>

<style></style>
